<template>
  <div id="scheduleComfirmationModal">
    <BModal id="signinModal" ref="signinModal" hide-footer hide-header
centered
>
      <div class="signin-modal">
        <div class="signin-modal-close">
          <BaseIcon icon="cross" size="xs" @click="closeSigninModal" />
        </div>

        <div class="signin-modal-container">
          <h4 class="signin-modal-title">Necessita autenticação!</h4>
          <p class="signin-modal-text">
            Você precisa estar autenticado para continuar, faça login ou crie
            uma nova conta.
          </p>
          <BaseButton
            class="mb-2"
            size="xl"
            block
            @click="loginOrCreate('Login')"
          >
            Entrar
          </BaseButton>
          <BaseButton
            variant="light"
            class="mb-3"
            size="xl"
            block
            @click="loginOrCreate('Register')"
          >
            Crie uma conta
          </BaseButton>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ScheduleComfirmationModal',
  methods: {
    closeSigninModal() {
      this.$bvModal.hide('signinModal');
    },
    loginOrCreate(urlName) {
      this.$router.push({
        name: urlName,
        query: this.slotsRequested && {
          edirectFrom: `/?sms_to_doctor=${this.slotsRequestedDoctorId}`,
        },
      });
    },
  },
  computed: {
    ...mapGetters('slot', ['slotsRequested', 'slotsRequestedDoctorId']),
  }
};
</script>
